import toBoolean from './toBoolean';
export default toBoolean;